const INVALID_CODE_FIELD_ALIASES = [
  ["invalidCodeMaxAttempts", "invalid_code_max_attempts"],
  ["invalidCodeTimeframeMinutes", "invalid_code_timeframe_minutes"],
  ["invalidCodeLockoutDurationMinutes", "invalid_code_lockout_duration_minutes"],
];

export function normalizeUserLoginLimits(settings) {
  const normalized = { ...(settings || {}) };

  INVALID_CODE_FIELD_ALIASES.forEach(([canonicalField, legacyField]) => {
    const hasCanonicalField = Object.prototype.hasOwnProperty.call(
      normalized,
      canonicalField
    );

    if (
      !hasCanonicalField &&
      Object.prototype.hasOwnProperty.call(normalized, legacyField)
    ) {
      normalized[canonicalField] = normalized[legacyField];
    }

    delete normalized[legacyField];
  });

  return normalized;
}
